import { createSlice } from "@reduxjs/toolkit";
import { INITIAL_SLIDE_STATE } from "../../constants/states";

const initialState = {
  slides: [{ ...INITIAL_SLIDE_STATE, label: "1" }],
  currentPreviewSlide: 0,
  currentSlideIndex: 0,
  loading: false,
};

const slidesSlice = createSlice({
  name: "slides",
  initialState,
  reducers: {
    setSlideLoading: (state, action) => {
      state.loading = action.payload ?? !state.loading;
    },
    setCurrentSlideIndex: (state, action) => {
      state.currentSlideIndex = action.payload;
    },
    setCurrentPreviewSlide: (state, action) => {
      state.currentPreviewSlide = action.payload;
    },
    // add object to the slide.
    addObject: (state, action) => {
      const { slideIndex, data } = action.payload;
      const slideIndexToBeUpdated = slideIndex ?? state.currentSlideIndex;

      state.slides[slideIndexToBeUpdated].objects.push(data);
    },
    // payload would be add slide in b/w two slide
    // pass prev slide index where want to add.
    addSlide: (state, action) => {
      const initialData = {
        ...INITIAL_SLIDE_STATE,
        label: state.slides.length + 1,
      };
      if (action.payload !== undefined) {
        state.slides.splice(action.payload + 1, 0, initialData);
        state.slides = state.slides.map((s, index) => {
          return { ...s, label: index + 1 };
        });
      } else {
        state.slides.push({
          ...initialData,
        });
      }
    },
    removeSlide: (state, action) => {
      state.slides.splice(action.payload, 1);
      state.slides = state.slides.map((s, index) => {
        return { ...s, label: index + 1 };
      });
    },
    duplicateSlide: (state, action) => {
      const copySlide = state.slides[action.payload];
      const initialData = {
        ...INITIAL_SLIDE_STATE,
        ...copySlide,
      };
      state.slides.splice(action.payload + 1, 0, initialData);
      state.slides = state.slides.map((s, index) => {
        return { ...s, label: index + 1 };
      });
    },
    setSlides: (state, action) => {
      state.slides = action.payload;
    },
    updateObject: (state, action) => {
      const { data, slideIndex } = action.payload;
      const slideIndexToBeUpdated = slideIndex ?? state.currentSlideIndex;

      const findIndex = state.slides[slideIndexToBeUpdated].objects.findIndex(
        (ele) => ele.id === data.id
      );
      if (findIndex !== -1) {
        state.slides[slideIndexToBeUpdated].objects.splice(findIndex, 1, data);
      }
    },
    updateBackgroundColorObject: (state, action) => {
      const { data, slideIndex } = action.payload;

      const slideIndexToBeUpdated = slideIndex ?? state.currentSlideIndex;

      const findIndex = state.slides[slideIndexToBeUpdated].objects.findIndex(
        (ele) => ele.type === "backgroundColor"
      );
      if (findIndex !== -1) {
        state.slides[slideIndexToBeUpdated].objects.splice(findIndex, 1, data);
      } else {
        state.slides[slideIndexToBeUpdated].objects.push(data || {});
      }
    },
    removeObject: (state, action) => {
      const { data, slideIndex } = action.payload;
      const slideIndexToBeUpdated = slideIndex ?? state.currentSlideIndex;

      const findIndex = state.slides[slideIndexToBeUpdated].objects.findIndex(
        (ele) => ele.id === data.id
      );
      if (findIndex !== -1) {
        state.slides[slideIndexToBeUpdated].objects.splice(findIndex, 1);
      }
    },
    updateSlideThumbnail: (state, action) => {
      if (state.slides[state.currentSlideIndex])
        state.slides[state.currentSlideIndex].thumbnail = action.payload;
    },
    updateSlideLanguage: (state, action) => {
      state.slides[state.currentSlideIndex].language = action.payload;
    },
    updateSlideVoice: (state, action) => {
      state.slides[state.currentSlideIndex].voice = action.payload;
    },
    updateSlideVoiceFile: (state, action) => {
      state.slides[state.currentSlideIndex].voiceFile = action.payload;
    },
    updateSlideScript: (state, action) => {
      state.slides[state.currentSlideIndex].script = action.payload;
    },
    updateSlideOriginalScript: (state, action) => {
      state.slides[state.currentSlideIndex].originalScript = action.payload;
    },
    updateSlideTransitions: (state, action) => {
      state.slides[state.currentSlideIndex].transitionData = action.payload;
    },
    updateGeneratedVoice: (state, action) => {
      state.slides[state.currentSlideIndex].generatedVoice = action.payload;
    },
    setUserVoice: (state, action) => {
      state.slides[state.currentSlideIndex].is_user_audio = action.payload;
    },
    setElevenLabsVoice: (state, action) => {
      state.slides[state.currentSlideIndex].elevenlabs_voice = action.payload;
    },

    setOpenAiVoiceId: (state, action) => {
      state.slides[state.currentSlideIndex].isOpenAiVoiceId = action.payload;
    },

    updateSubtitle: (state, action) => {
      state.slides[state.currentSlideIndex].subtitle = action.payload;
    },
    updateCurrentElevanLabVoiceAccents: (state, action) => {
      state.slides[state.currentSlideIndex].elevenlabs_voice_accents =
        action.payload;
    },
    updateCurrentElevanLabVoiceGender: (state, action) => {
      state.slides[state.currentSlideIndex].elevenlabs_voice_gender =
        action.payload;
    },
    updateCurrentElevanLabVoiceAge: (state, action) => {
      state.slides[state.currentSlideIndex].elevenlabs_voice_age =
        action.payload;
    },

    updateAccentVoice: (state, action) => {
      state.slides[state.currentSlideIndex].accent_voice = action.payload;
    },
    updateSlide: (state, action) => {
      const currentSlide = state.slides[state.currentSlideIndex];
      state.slides.splice(state.currentSlideIndex, 1, {
        ...currentSlide,
        ...action.payload,
      });
    },
  },
});

export const {
  addSlide,
  updateSlide,
  setCurrentPreviewSlide,
  updateSlideThumbnail,
  updateSlideLanguage,
  updateSlideScript,
  updateSlideVoice,
  updateSlideVoiceFile,
  updateGeneratedVoice,
  setSlides,
  removeSlide,
  duplicateSlide,
  updateSlideTransitions,
  setCurrentSlideIndex,
  addObject,
  removeObject,
  updateObject,
  setSlideLoading,
  setUserVoice,
  updateSlideOriginalScript,
  setElevenLabsVoice,
  updateSubtitle,
  updateBackgroundColorObject,
  updateCurrentElevanLabVoiceAccents,
  updateCurrentElevanLabVoiceGender,
  updateCurrentElevanLabVoiceAge,
  setOpenAiVoiceId,
  updateAccentVoice,
} = slidesSlice.actions;
export default slidesSlice.reducer;
